// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React from 'react'
import PropTypes from 'prop-types'

import { RadioGroup } from '../'


export const CancelForm = ({ cancelledBy, onSelect }) => (
  <div className='slds-grid' style={{ justifyContent: 'center' }}>
    <RadioGroup
      label={<strong>Withdrawal cancelled by:</strong>}
      options={[
        {
          label: 'Client (e.g. requested over phone call)',
          value: 'cancelled_client'
        },
        {
          label: 'Picsa',
          value: 'cancelled_internal'
        }
      ]}
      value={cancelledBy}
      onClick={onSelect}
      className='slds-p-bottom_medium'
    />
  </div>
)

CancelForm.propTypes = {
  cancelledBy: PropTypes.string,
  onSelect: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/withdrawal-detail/CancelForm.js